




















































































































































































































































































import { Component, Prop } from "vue-property-decorator";
import _ from "lodash";

import AppVue from "@/AppVue.vue";
import { QuestionnaireLookups, QuestionnaireModel, MultiInputSumModel, Map } from "@/core/models";
import {
  InputTextareaCpt,
  InputNumberCpt,
  InputDateCpt,
  InputSelectCpt,
  InputRadioCpt,
  MultiInputSumCpt,
} from "@/core/components";

@Component({
  components: {
    InputTextareaCpt,
    InputNumberCpt,
    InputDateCpt,
    InputSelectCpt,
    InputRadioCpt,
    MultiInputSumCpt,
  },
})
export default class QuestionnaireStep1Cpt extends AppVue {
  @Prop() lookups: QuestionnaireLookups;
  @Prop() model: QuestionnaireModel;
  @Prop({ default: false }) disabled: boolean;
}
